document.addEventListener("product:variant-change", function (evt) {
    console.log("Product variant changed");
    console.log(evt.detail.variant.featured_media.alt);
if(evt.detail.variant.featured_media.alt)
{
  // set vars
var slider = $('#Product-Slider');

function flicitySlider() {
  //init flickity
  slider.flickity({
    contain: true,
    imagesLoaded: true,
    cellAlign: 'left',
    cellSelector: '.flickity'
  });
}

flicitySlider();

//bind next to next button
slider.find('.flickity-next').on('click', function() {
  slider.flickity('next');
});

//bind previous to previous button
slider.find('.flickity-prev').on('click',function() {
  slider.flickity('previous');
});

//when filter buttons clicked

  //use data-filter attribute & class for filtering 
  var filterValue = evt.detail.variant.featured_media.alt;
  var slide = slider.find('.product-images__slide');

 
    var active = $('.product-images__slide[slider-name="' + filterValue + '"]').fadeIn(450);
    // show only slide with the same class as the button "attr('data-filter')"
    slide.addClass('flickity');
    slide.not(active).removeClass('flickity');
    slide.not(active).hide();

    var activeThumb = $('.product-thumbnail[slider-name="' + filterValue + '"]').fadeIn(450);
    // show only slide with the same class as the button "attr('data-filter')"
    $('.product-thumbnail').not(activeThumb).removeClass('flickity');
    $('.product-thumbnail').not(activeThumb).hide();
  
  // destroy slider so we can rebuild with new filters
  slider.flickity('destroy');

  //rebuild slider with new images
  flicitySlider();
  
  // Update zoom functionality for the new variant
  // Find the product slider element and update its zoom items
  const productSlider = document.querySelector('#Product-Slider');
  if (productSlider && productSlider.buildItems) {
    // Force rebuild of zoom items for the new variant
    productSlider.items = productSlider.buildItems();
  }
}
});

window.addEventListener("load", function() {
      // set vars
var slider = $('#Product-Slider');

function flicitySlider() {
  //init flickity
  slider.flickity({
    contain: true,
    imagesLoaded: true,
    cellAlign: 'left',
    cellSelector: '.flickity'
  });
}

flicitySlider();

//bind next to next button
slider.find('.flickity-next').on('click', function() {
  slider.flickity('next');
});

//bind previous to previous button
slider.find('.flickity-prev').on('click',function() {
  slider.flickity('previous');
});

//when filter buttons clicked

  //use data-filter attribute & class for filtering 
  var filterValue = $('.is-initial-selected').attr('slider-name');
  var slide = slider.find('.product-images__slide');

 
    var active = $('.product-images__slide[slider-name="' + filterValue + '"]').fadeIn(450);
    // show only slide with the same class as the button "attr('data-filter')"
    slide.addClass('flickity');
    slide.not(active).removeClass('flickity');
    slide.not(active).hide();

    var activeThumb = $('.product-thumbnail[slider-name="' + filterValue + '"]').fadeIn(450);
    // show only slide with the same class as the button "attr('data-filter')"
    $('.product-thumbnail').not(activeThumb).removeClass('flickity');
    $('.product-thumbnail').not(activeThumb).hide();
  
  // destroy slider so we can rebuild with new filters
  slider.flickity('destroy');

  //rebuild slider with new images
  flicitySlider();
  
  // Update zoom functionality for the initial variant
  // Find the product slider element and update its zoom items
  const productSlider = document.querySelector('#Product-Slider');
  if (productSlider && productSlider.buildItems) {
    // Force rebuild of zoom items for the initial variant
    productSlider.items = productSlider.buildItems();
  }
});